/// <amd-module name="Build/Admin/PoolsList/Stores/CreatePoolPanelStore" />
import { Store } from "VSS/Reflux/Store";

import { PoolType } from "Build/Admin/Common/Client/Contracts/DistributedTask/DataProvider";

export interface ICreatePoolPanelStoreState {
    isOpen: boolean;
    availablePoolTypes: PoolType[];
}

export class CreatePoolPanelStore extends Store {
    public state: ICreatePoolPanelStoreState;

    constructor() {
        super("CreatePoolPanelStoreChanged");

        this.state = {
            isOpen: false,
            availablePoolTypes: [PoolType.Private]
        };
    }

    public showPanel = (): void => {
        this.state = {
            ...this.state,
            isOpen: true
        };
        this.emitChanged();
    }

    public dismissPanel = (): void => {
        this.state = {
            ...this.state,
            isOpen: false
        };
        this.emitChanged();
    }

    public availablePoolTypesUpdated = (availablePoolTypes: PoolType[]): void => {
        this.state = {
            ...this.state,
            availablePoolTypes
        };
        this.emitChanged();
    }
}
